// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"125420de","227":"ebedbd15","357":"cf5e1c2d","503":"47a05791","826":"a8daaa81","864":"e20a7306"}[chunkId] + ".chunk.js";
};